import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { SUPPORTED_LOCALES, LOCALE_META } from '@/i18n/translations';
import { stripLocalePath } from '@/i18n/I18nContext';
import { SEO_BASE_URL } from '@/components/SEOHead';

const BASE_URL = SEO_BASE_URL;
const BLOCKED_PREFIXES = ['/admin', '/account', '/checkout', '/reset-password'];
const LEGAL_PATHS = ['/refund-policy', '/privacy-policy', '/terms'];
const PRIMARY_LOCALES = ['fr', 'en-gb'] as const;

const HrefLangTags: React.FC = () => {
  const location = useLocation();
  const stripped = stripLocalePath(location.pathname);

  if (BLOCKED_PREFIXES.some(p => stripped === p || stripped.startsWith(p + '/'))) {
    return null;
  }

  const isLegalPage = LEGAL_PATHS.includes(stripped);
  const locales = isLegalPage
    ? SUPPORTED_LOCALES.filter(l => (PRIMARY_LOCALES as readonly string[]).includes(l))
    : SUPPORTED_LOCALES;

  return (
    <Helmet>
      {locales.map(l => (
        <link
          key={l}
          rel="alternate"
          hrefLang={LOCALE_META[l].htmlLang}
          href={`${BASE_URL}/${l}${stripped === '/' ? '' : stripped}`}
        />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${BASE_URL}/fr${stripped === '/' ? '' : stripped}`} />
    </Helmet>
  );
};

export default HrefLangTags;
